import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

export const useIsSiteRoot = () => {
    const location = useLocation();
    const [isRoot, setIsRoot] = useState<boolean>(false);

    useEffect(() => {
        setIsRoot(location.pathname === '/');
    }, [location]);

    return isRoot;
};
